"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _useDocuments = _interopRequireDefault(require("../../../ProductDetail/hooks/useDocuments"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ReactFile01 = (0, _component.default)(() => import("@micado-digital/react-file/ReactFile01"));
const Documents = _ref => {
  let {
    lang = "de"
  } = _ref;
  const documents = (0, _useDocuments.default)({
    lang
  });
  const {
    items = []
  } = documents || {};
  if ((0, _isEmpty.default)(items)) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-product-detail-documents"
  }, items === null || items === void 0 ? void 0 : items.map((item, index) => {
    const {
      title = "",
      ...media
    } = item;
    return /*#__PURE__*/_react.default.createElement(ReactFile01, {
      absoluteMediaURL: true,
      key: index,
      media: [media],
      title: title
    });
  }));
};
Documents.propTypes = {
  lang: _propTypes.default.string
};
var _default = exports.default = Documents;